import { Box, chakra, Text, useRadio, UseRadioProps, VStack, useColorModeValue as mode } from '@chakra-ui/react';
import * as React from 'react';
import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md';

const RadioBox = chakra('div', {
  baseStyle: {
    borderWidth: '3px',
    px: '6',
    pt: '12',
    pb: '8',
    borderRadius: 'md',
    cursor: 'pointer',
    transition: 'all 0.2s',
    shadow: 'lg',
    _focus: { shadow: 'lg' }
  }
});

const CheckboxIcon = ({ checked }: { checked: boolean }) => (
  <Box fontSize='4xl' color={checked ? 'orange.500' : mode('gray.300', 'whiteAlpha.400')}>
    {checked ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />}
  </Box>
);

interface ButtonRadioProps extends UseRadioProps {
  icon: React.ReactElement;
  label: string;
  description: string;
}

export const ButtonRadio = (props: ButtonRadioProps) => {
  const { label, icon, description } = props;
  const { getCheckboxProps, getInputProps, getLabelProps, state } = useRadio(props);

  const checkedStyles = {
    bg: mode('orange.50', 'rgb(0 31 71)'),
    borderColor: 'orange.500'
  };

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label style={{ width: '100%' }} {...getLabelProps()}>
      <input {...getInputProps()} />
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <RadioBox {...getCheckboxProps()} _checked={checkedStyles}>
        <VStack spacing='4'>
          <VStack textAlign='center'>
            <Box aria-hidden fontSize='4xl' mb='3' color={state.isChecked ? 'orange.500' : undefined}>
              {icon}
            </Box>
            <Text fontWeight='extrabold' fontSize='xl'>
              {label}
            </Text>
            <Text fontSize='sm' px={2}>{description}</Text>
          </VStack>
          <CheckboxIcon checked={state.isChecked} />
        </VStack>
      </RadioBox>
    </label>
  );
};
